<fn-modal-header class="modal-header">
    <h5 class="modal-title" mat-dialog-title>Schema</h5>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
    </button>
</fn-modal-header>
<mat-dialog-content>
    <div class="row mb-3">
        <div class="col-6">
            <label for="id" class="form-label">Schema Name</label>
            <fn-base-input
                placeholder="Enter SchemaName"
                [(ngModel)]="objectHash.schemaName"
                [ngModelOptions]="{ standalone: true }"
            ></fn-base-input>
        </div>
        <div class="col-6">
            <label for="teams" class="form-label">Teams</label>
            <fn-multi-select
                [labelKey]="'name'"
                [inputKey]="'primaryKey'"
                [optionList]="teamsArray"
                [placeholder]="'Select Teams'"
                [(ngModel)]="objectHash.teams"
                [appendTo]="'mat-dialog-container'"
            ></fn-multi-select>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <div class="row">
        <div class="col-6 text-left">
            <button class="btn btn-danger btn-round" (click)="close()">Cancel</button>
        </div>
        <div class="col-6 text-right">
            <button class="btn btn-primary btn-round" (click)="add()">Add</button>
        </div>
    </div>
</mat-dialog-actions>
